import type { EditorDoc } from "@/lib/doc/doc-types";
import { RenderEditorDoc } from "@/lib/doc/render-editor-doc";

type BlockDocRendererProps = {
  doc: EditorDoc;
  className?: string;
};

/** Public read-only renderer — lightweight HTML, no BlockNote/Mantine. */
export function BlockDocRenderer({ doc, className }: BlockDocRendererProps) {
  return <RenderEditorDoc doc={doc} className={className} />;
}
